import {ResolutionBreak, getResolutionBreak} from '../shared'
import {useEffect, useState} from 'react'

/**
 * Get the window resolution.
 * @returns width/height resolution, or 0,0 if running on server.
 */
function getDocumentBodyDimensions() {
  if (typeof document === 'undefined') {
    return {
      width: 0,
      height: 0
    }
  }

  const {clientWidth, clientHeight} = document.body

  return {
    width: clientWidth,
    height: clientHeight
  }
}

/**
 * Watch window size to get the current resolution break.
 *
 * @returns Current resolution break identifier.
 */
export function useResolutionBreak(defaultBreak: ResolutionBreak = 'md') {
  const [resolutionBreak, setResolutionBreak] = useState(defaultBreak)

  useEffect(() => {
    function handleResize() {
      const {width} = getDocumentBodyDimensions()
      const resolutionName = getResolutionBreak(width)
      setResolutionBreak(resolutionName)
    }

    window.addEventListener('load', handleResize)
    window.addEventListener('orientationchange', handleResize)
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => {
      window.removeEventListener('load', handleResize)
      window.removeEventListener('orientationchange', handleResize)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return resolutionBreak
}
